import React, { useEffect, useState } from "react";
import './DoorPage.css';
import moment from 'moment';
import { useDispatch, useSelector } from "react-redux";
import { getLoading, createDeviceAsync, setDevicesLoading, deleteDeviceAsync, updateDeviceAsync } from "../../../features/redux/adminSlice";
import Confirm from "../../ui/Confirm/Confirm";
import SideSlider from "../../ui/SideSlider/SideSlider";
import { useForm } from 'react-forms-handler';
import validator from 'validator';

const globals = { devices: [] };

function DoorPage({ devices, offices }) {
  const dispatch = useDispatch();
  const isLoading = useSelector(getLoading);
  const [filteredDevices, setFilteredDevices] = useState(devices);
  const [openForm, setOpenForm] = useState(false);
  const { form, valid, value, id, name, office_id, home_assistant_id, type } = useForm({
    id: [''],
    name: ['', (str) => !validator.isEmpty(str)],
    office_id: ['', (str) => !validator.isEmpty(str)],
    home_assistant_id: ['', (str) => !validator.isEmpty(str)],
    type: ['', (str) => !validator.isEmpty(str)],
  });

  const { searchField } = useForm({
    searchField: ['']
  });

  useEffect(() => {
    globals.devices = devices;
    setFilteredDevices(devices.filter(d => getSearchableText(d).toLowerCase().includes(searchField.value.toLowerCase())));
  }, [devices, searchField]);

  useEffect(() => {
    searchField.stateChange.subscribe((currentValue) => {
      setFilteredDevices(devices.filter(d => getSearchableText(d).toLowerCase().includes(currentValue.toLowerCase())));
    });
  }, [searchField]);

  const getOfficeName = (officeId) => {
    const office = offices.find(o => o.id === officeId);
    return office ? office.name : 'Unknown Office';
  };


  return (
    <div className="devices-dashboard-content">
      <div className="dashboard-header">
        <h1>Admin Dashboard Devices</h1>
        <input style={{ width: '20%' }} type="text" className="form-control" {...searchField.inputProps} placeholder="Search" />
        <button className="btn btn-primary" onClick={() => { setOpenForm(true) }}>Add Device</button>
      </div>
      <table className="table">
        <thead className="thead-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col">Office</th>
             <th scope="col">Home Assistant ID</th>
            <th scope="col">Type</th>
            <th scope="col">Created At</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredDevices.map((device, index) => {
            return (
              <tr key={`device-${index}`} className={`${device.deleted_at ? 'deleted' : ''}`}>
                <th scope="row">{index + 1}</th>
                <td>{device.name}</td>
                <td>{getOfficeName(device.office_id)}</td>
                 <td>{device.home_assistant_id}</td>
                <td>{device.type}</td>
                <td>{moment(device.createdAt).format("MMM Do YY")}</td>
                {!device.deleted_at && (
                  <td>
                    <i
                      className={`text-danger fa-solid fa-${
                        isLoading.devices !== device.id ? 'trash' : 'circle-notch fa-spin'
                      }`}
                      onClick={() => {
                        Confirm.confirm('Are you sure you want to delete this device? This action cannot be undone').then(() => {
                          dispatch(setDevicesLoading(device.id));
                          dispatch(deleteDeviceAsync(device.id));
                        }).catch((e) => {
                          console.log(e);
                        });
                      }}
                    ></i>
                    <i
                      style={{ marginLeft: '4px', cursor: 'pointer' }}
                      className={`text-primary fa-solid fa-edit`}
                      onClick={() => {
                        form.clearAllFields();
                        id.value = device.id;
                        name.value = device.name;
                        office_id.value = device.office_id;
                        home_assistant_id.value = device.home_assistant_id;
                        type.value = device.type;
                        setOpenForm(true);
                      }}
                    ></i>
                  </td>
                )}
                {device.deleted_at && (
                  <td>
                    <i
                      style={{ cursor: 'pointer' }}
                      className={`text-success fa-solid fa-${
                        isLoading.devices !== device.id ? 'trash-restore' : 'circle-notch fa-spin'
                      }`}
                      onClick={() => {
                        Confirm.confirm('Are you sure you want to restore this device?').then(() => {
                          dispatch(setDevicesLoading(device.id));
                        }).catch((e) => {
                          console.log(e);
                        });
                      }}
                    ></i>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      <SideSlider open={openForm}>
        <i
          style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer' }}
          className={`text-primary fa-solid fa-rectangle-xmark`}
          onClick={() => {
            setOpenForm(false);
            form.clearAllFields();
          }}
        ></i>
        <form style={{ textAlign: 'left' }}>
          <div className="form-group">
            <label>Name</label>
            <input type="text" {...name.inputProps} className="form-control" placeholder="Enter name" />
            {name.touched && !name.valid && <small className="form-text text-danger">Cannot be empty</small>}
          </div>
          <div className="form-group">
            <label>Office</label>
            <select {...office_id.inputProps} className="form-control">
              {offices.map((office) => (
                <option key={office.id} value={office.id}>{office.name}</option>
              ))}
            </select>
            {office_id.touched && !office_id.valid && <small className="form-text text-danger">Cannot be empty</small>}
          </div>
          <div className="form-group">
            <label>Home Assistant ID</label>
            <input type="text" {...home_assistant_id.inputProps} className="form-control" placeholder="Enter home assistant ID" />
            {home_assistant_id.touched && !home_assistant_id.valid && <small className="form-text text-danger">Cannot be empty</small>}
          </div>
          <div className="form-group">
            <label>Type</label>
            <input type="text" {...type.inputProps} className="form-control" placeholder="Enter type" />
            {type.touched && !type.valid && <small className="form-text text-danger">Cannot be empty</small>}
          </div>
          <button disabled={!valid || isLoading.devices} type="submit" className="btn btn-primary" onClick={(e) => {
            if (id.value) {
              dispatch(updateDeviceAsync(value));
            } else {
              dispatch(createDeviceAsync(value));
            }
            setOpenForm(false);
            form.clearAllFields();
            e.preventDefault();
          }}>Submit</button>
        </form>
      </SideSlider>
    </div>
  );
}

function getSearchableText(device) {
  return `${device.name}${device.office_id}${device.home_assistant_id}${device.type}${moment(device.createdAt).format("MMM Do YY")}`;
}

export default DoorPage;
